import React, { useState, useEffect, useContext } from "react";
import Modal from "../../Modal";
import UserGroupTable from "./UserGroupTable";
import AddedUserGroupTable from "./AddedUserGroupTable";
import Tabs from "../../Tabs";
import apiRequest from "../../../services/apiRequest";
import { NotificationsContext } from "../../Notifications";
import { useIntl } from "react-intl";

function AddUserToGroupDialog({ open, toggleOpen, selectedGroup }) {
  const [tab, setTab] = useState(0);
  const intl = useIntl();
  const [addedUsers, setAddedUsers] = useState();
  const [notAddedUsers, setNotAddedUsers] = useState();
  const [removedAddedUsers, triggerRemovedAddedUsers] = useState(true);
  const { push } = useContext(NotificationsContext);

  useEffect(() => {
    function fetchNotInGroupUsers() {
      if (selectedGroup) {
        apiRequest
          .get(`/groups/not-in-group-users/${selectedGroup}`)
          .then((res) => {
            setNotAddedUsers(res);
          })
          .catch(() => {
            setNotAddedUsers([]);
            push({
              title: intl.formatMessage({ id: "server_error" }),
              type: "error",
            });
          });
      }
    }
    fetchNotInGroupUsers();
  }, [selectedGroup, removedAddedUsers]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    function fetchInGroupUsers() {
      if (selectedGroup) {
        apiRequest
          .get(`/groups/in-group-users/${selectedGroup}`)
          .then((res) => {
            setAddedUsers(res);
          })
          .catch(() => {
            setAddedUsers([]);
            push({
              title: intl.formatMessage({ id: "server_error" }),
              type: "error",
            });
          });
      }
    }
    fetchInGroupUsers();
  }, [selectedGroup, removedAddedUsers]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleRefreshUserGroupData = () =>
    triggerRemovedAddedUsers(!removedAddedUsers);

  if (!open) {
    return <></>;
  }

  return (
    <div>
      <Modal onExit={toggleOpen} large={true}>
        <Tabs
          setActiveTab={(e) => setTab(e)}
          active={tab}
          tabs={[{ name: "Lista Utenti" }, { name: "Utenti Aggiunti" }]}
        />
        <div className="m-8">
          {tab === 0 ? (
            <UserGroupTable
              users={notAddedUsers}
              selectedGroup={selectedGroup}
              refresh={toggleRefreshUserGroupData}
            />
          ) : (
            <AddedUserGroupTable
              users={addedUsers}
              selectedGroup={selectedGroup}
              refresh={toggleRefreshUserGroupData}
            />
          )}
        </div>
      </Modal>
    </div>
  );
}

export default AddUserToGroupDialog;
